import API from '@/views/Fdc/Apis/'
import MonacoEditor from '../Components/MonacoEditor'
import Dayjs from 'dayjs'
import LotsModal from '@/views/Fdc/Detection/Components/LotsModal'
import BriqueChart from '@/components/BriqueChart/BriqueChart.js'

/**
 * TODO: 수정해야 할 항목 정리
 */
// FIXME: 1. drag & drop?

export default {
  name: 'FdcVirtualParameter',
  components: {
    'monaco-editor': MonacoEditor, // Monace Editor
    'lots-modal': LotsModal // Select Lot Modal
  },
  watch: {
    /**
     * fromDate 변화 감지
     * fromDate/fromTime, toDate/toTime의 min,max값을 설정합니다.
     */
    fromDate () {
      this.toMinDate = this.fromDate
      let fromDate = Dayjs(this.fromDate).format('YYYYMMDD')
      let toDate = Dayjs(this.toDate).format('YYYYMMDD')

      if (fromDate === toDate) {
        this.toMinTime = this.fromTime
        this.fromMaxTime = this.toTime
        if (this.fromTime > this.toTime) {
          this.fromTime = null
        }
      } else {
        this.toMinTime = null
        this.fromMaxTime = null
      }
    },
    /**
     * toDate 변화 감지
     * fromDate/fromTime, toDate/toTime의 min,max값을 설정합니다.
     */
    toDate () {
      this.fromMaxDate = this.toDate
      let fromDate = Dayjs(this.fromDate).format('YYYYMMDD')
      let toDate = Dayjs(this.toDate).format('YYYYMMDD')

      if (fromDate === toDate) {
        this.toMinTime = this.fromTime
        this.fromMaxTime = this.toTime
        if (this.toTime < this.fromTime) {
          this.toTime = null
        }
      } else {
        this.toMinTime = null
        this.fromMaxTime = null
      }
    },
    /**
     * fromTime 변화 감지
     * fromTime, toTime의 min,max값을 설정합니다.
     */
    fromTime () {
      if (this.fromDate !== null && this.toDate !== null) {
        let fromDate = Dayjs(this.fromDate).format('YYYYMMDD')
        let toDate = Dayjs(this.toDate).format('YYYYMMDD')

        if (fromDate === toDate) {
          this.toMinTime = this.fromTime
        } else {
          this.toMinTime = null
        }
      }
    },
    /**
     * toTime 변화 감지
     * fromTime, toTime의 min,max값을 설정합니다.
     */
    toTime () {
      if (this.fromDate !== null && this.toDate !== null) {
        let fromDate = Dayjs(this.fromDate).format('YYYYMMDD')
        let toDate = Dayjs(this.toDate).format('YYYYMMDD')

        if (fromDate === toDate) {
          this.fromMaxTime = this.toTime
        } else {
          this.fromMaxTime = null
        }
      }
    }
  },
  beforeMount () {
    this.getCodeList('freeDefineFunctionName')
    this.initColumns()
  },
  mounted () {
    let params = this.$route.query
    if (params.fab && params.eqpId && params.moduleId && params.paramName) {
      this.nodeObj = this.$route.query
      // this.searchTreeNode.detail = params
      // this.listFn(params.fab, params.eqpId, params.moduleId)
      this.getParam(params.fab, params.eqpId, params.moduleId, params.paramName)
    }

    // TODO: drag & drop 필요 여부 판단!!
    // this._makeDragSource(this.parameterListGrid)
    // this._makeDropTarget(document.querySelector('#theTarget'))
  },
  methods: {
    /**
     * Column initialize
     */
    initColumns () {
      this.columns = [
        { headerName: this.$t('fdc.COMMON.COLUMN.PARAM_NAME'), field: 'paramName', flex: 2 },
        { headerName: this.$t('fdc.COMMON.COLUMN.ALIAS_NAME'), field: 'aliasName', flex: 2 },
        { headerName: this.$t('fdc.COMMON.COLUMN.VIRTUAL'), field: 'virtualYn', flex: 1 }
      ]
    },
    /**
     * 스플릿 패널 리사이즈 시 플라틀리 리사이즈
     * 윈도우 리사이즈 이벤트 생성해서 디스패치
     */
    splitPanesResized () {
      window.dispatchEvent(new Event('resize'))
    },
    /**
     * Parameter 목록 조회
     * @param {String} fab Fab
     * @param {String} eqpId EQP ID
     * @param {String} moduleId Module ID
     */
    async listFn (fab, eqpId, moduleId) {
      let payload = {
        fab: fab,
        eqpId: eqpId,
        moduleId: moduleId,
        useYn: 'Y'
      }
      let data = await API.BaseInfo.getEqpParams(payload)
      this.rowData = data.filter(d => d.virtualYn === 'Y')
      this.editorParamList = data
      // this.parameterListGrid.select(-1, -1)
    },
    /**
     * Context Name 목록 조회
     */
    async contextNameListFn () {
      // context mapping plan에 있는 contextName?
      let payload = {
        codeType: 'contextName'
      }
      let data = await API.Common.getCodesString(payload)
      this.editorContextNameList = data
    },
    /**
     * Step 목록 조회
     * @param {String} fab Fab
     * @param {String} eqpId EQP ID
     * @param {String} moduleId Module ID
     */
    async stepListFn (fab, eqpId, moduleId) {
      let payload = {
        fab: fab,
        eqpId: eqpId,
        moduleId: moduleId,
        useYn: 'Y'
      }
      let stepList = await API.BaseInfo.getEqpRecipeSteps(payload)
      // 같은 stepId일 경우 distinct 처리
      let stepIdList = []
      for (let obj of stepList) {
        if (!stepIdList.includes(obj.stepId)) {
          stepIdList.push(obj.stepId)
        }
      }
      this.editorStepList = stepIdList
    },
    /**
     * Virtual Parameter 조회
     * @param {String} fab Fab
     * @param {String} eqpId EQP ID
     * @param {String} moduleId Module ID
     * @param {String} paramName Parameter Name
     */
    async getParam (fab, eqpId, moduleId, paramName) {
      let payload = {
        fab: fab,
        eqpId: eqpId,
        moduleId: moduleId,
        paramName: paramName
      }
      let data = await API.FdcEqpInfo.getParam(payload)
      this.parameterData = data
      this.paramName = data.paramName
      if (data.virtualData !== null) {
        this.code = data.virtualData
      }
      this.isNew = false
    },
    /**
     * Parameter List Grid row drag event 설정
     * @param {*} s Parameter List Grid
     */
    _makeDragSource (s) {
      s.itemFormatter = (panel, r, c, cell) => {
        cell.draggable = true
      }

      s.addEventListener(
        s.hostElement,
        'dragstart',
        e => {
          let ht = s.hitTest(e)
          e.dataTransfer.effectAllowed = 'copy'
          e.dataTransfer.setData('text', ht.row.toString())
        },
        true
      )
    },
    /**
     * Parameter List Grid row drop event 설정
     * @param {*} s drop target
     */
    _makeDropTarget (s) {
      s.addEventListener('dragover', e => {
        let dragRow = e.dataTransfer.getData('text')

        // var dragX = e.pageX, dragY = e.pageY;
        // console.log("X: "+dragX+" Y: "+dragY)
        if (dragRow != null) {
          e.dataTransfer.dropEffect = 'copy'
          e.preventDefault()
        }
      })
      s.addEventListener('drop', e => {
        let dragRow = e.dataTransfer.getData('text')
        if (dragRow === null) {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Parameter']))
        } else if (this.functionName === null) {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Function']))
        } else {
          let item = this.parameterListGrid.rows[parseInt(dragRow)].dataItem

          // let code = this.code
          // code = this.code + '\n' + 'getParameterValue("' + item.paramName + '", 0); // ' + this.$t('fdc.EQP_INFO.MESSAGE.CODE_DESC_004')
          // this.code = code

          // cursorPosition이 없을 경우에는 현재 editor에 있는 가장 마지막 줄에 첫번째 컬럼에 function drop 시킴
          let lineNumber = this.cursorPosition !== null ? this.cursorPosition.lineNumber : (this.$refs.MonacoEditor.editor.getModel().getLineCount())
          let columnNumber = this.cursorPosition !== null ? this.cursorPosition.column : this.$refs.MonacoEditor.editor.getPosition().column
          let editTxt = this.functionName
          // getPrevParameterValue,
          // getContextValue,
          // getParameterValues,
          // getRunTime,
          // getLotTimeout,
          // getSubstTimeout,
          // getTraceTimeout
          if (this.functionName === 'getParameterValue') {
            editTxt = editTxt + '("' + item.paramName + '");'
            // /* ' + this.$t('fdc.EQP_INFO.MESSAGE.CODE_DESC_004') + ' */'
          } else if (this.functionName === 'getPrevParameterValue') {
            editTxt = editTxt + '("' + item.paramName + '", prevseq);'
          } else if (this.functionName === 'getParameterValues') {
            editTxt = editTxt + '("' + item.paramName + '", step);'
          } else if (this.functionName === 'getContextValue') {
            editTxt = editTxt + '(contextName);'
          } else if (this.functionName === 'getRunTime') {
            editTxt = editTxt + '(step);'
          } else {
            editTxt = editTxt + '();'
          }

          this.$refs.MonacoEditor.editor.executeEdits('', [
            {
              range: {
                startLineNumber: lineNumber,
                startColumn: columnNumber,
                endLineNumber: lineNumber,
                endColumn: columnNumber
              },
              text: editTxt
            }
          ])

          this.$refs.MonacoEditor.editor.setPosition({
            lineNumber: lineNumber,
            column: columnNumber + editTxt.length
          })

          e.preventDefault()
        }
      })
    },
    /**
     * EQP Tree select시 수행하는 method
     * @param {Object} node 선택된 tree node data
     */
    eqpTreeSelected (node) {
      this.selectedTreeNode = node
    },
    /**
     * Parameter 목록 검색
     */
    searchProcess () {
      if (this.selectedTreeNode.length === 0) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Equipment']))
        return
      }
      let node = this.selectedTreeNode
      if (node.detail.moduleId === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Module ID']))
        return
      }
      this.searchTreeNode = this.selectedTreeNode

      this.$commonUtil.setStoreEqpTree(
        this.selectedTreeNode,
        this.$refs.fdcEqpTree.treeType
      )

      // Parameter List
      this.listFn(node.detail.fab, node.detail.eqpId, node.detail.moduleId)
      // Context Name List
      this.contextNameListFn()
      // Step List
      this.stepListFn(node.detail.fab, node.detail.eqpId, node.detail.moduleId)
      this.paramName = null
      this.code = this.codeGuide
      this.parameterData = null
      this.isNew = true
      this.functionName = 'getParameterValue'
      this.validationOption = 'period'
      this.selectedLots = []
      // this.chartData = []
      // this.yMax = null
      // this.yMin = null
    },
    /**
     * Javascript Code Validation
     * Validation Option과 Javascript Code로 chart data를 생성합니다.
     */
    async validationProcess () {
      let code = this.code
      if (this.validationOption === 'period') {
        let fromDate = Dayjs(this.fromDate).format('YYYYMMDD')
        let fromTime = Dayjs(this.fromTime).format('HHmm00000')
        let toDate = Dayjs(this.toDate).format('YYYYMMDD')
        let toTime = Dayjs(this.toTime).format('HHmm59999')

        if (!code || code.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Virtual Data']))
        } else if (!this.fromDate || fromDate.trim() === 'Invalid Date') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Start Date']))
        } else if (!this.fromTime || fromTime.trim() === 'Invalid Date') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Start Time']))
        } else if (!this.toDate || toDate.trim() === 'Invalid Date') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['End Date']))
        } else if (!this.toTime || toTime.trim() === 'Invalid Date') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['End Time']))
        } else {
          let params = {
            fab: this.searchTreeNode.detail.fab,
            eqpId: this.searchTreeNode.detail.eqpId,
            moduleId: this.searchTreeNode.detail.moduleId,
            virtualParamName: this.paramName,
            virtualData: code,
            fromDt: fromDate,
            fromTime: fromTime,
            toDt: toDate,
            toTime: toTime
          }

          this.validationCall(params)
        }
      } else if (this.validationOption === 'selectLot') {
        if (!code || code.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Virtual Data']))
        } else if (!(this.selectedLots.length > 0)) {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_EXIST', ['Selected LOT']))
        } else {
          let params = {
            fab: this.searchTreeNode.detail.fab,
            eqpId: this.searchTreeNode.detail.eqpId,
            moduleId: this.searchTreeNode.detail.moduleId,
            virtualParamName: this.paramName,
            virtualData: code,
            lotsList: this.selectedLots
          }

          this.validationCall(params)
        }
      } else {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Validation Option']))
      }
    },
    /**
     * Javascript Code Validation
     * @param {Object} params validation 조건
     */
    async validationCall (params) {
      let self = this
      let message = this.$t('fdc.EQP_INFO.MESSAGE.CONFIRM_VALIDATION')

      this.$dialog.confirm({
        message: message,
        cancelText: this.$t('fdc.COMMON.BUTTON.CANCEL'),
        confirmText: this.$t('fdc.COMMON.BUTTON.CONFIRM'),
        onConfirm: function () {
          // self.chartData = []
          // self.yMax = null
          // self.yMin = null
          API.FdcEqpInfo.virtualParamValidation(params).then(result => {
            if (!result) {
              self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.FAILED_EXEC_REQ'))
            } else {
              if (result.chartData.length > 0) {
                // self.chartData = result.chartData
                // self.yMax = result.yMax
                // self.yMin = result.yMin
                self.drawChart(result.chartData)
              } else {
                // self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_EXIST', ['Chart Data']))
                // TODO :: validation 결과에 따른 error message 처리 넣기!
                if (result.validResult === false) {
                  self.$dialog.alert(result.resultMsg)
                } else {
                  self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_EXIST', ['Chart Data']))
                }
              }
            }
          })
        },
        onCancel: function () {}
      })
    },
    /**
     * Validation Chart draw
     * @param {*} traces chart traces
     */
    drawChart (traces) {
      if (traces.length === 0) return

      traces.forEach(trace => {
        trace.type = 'scattergl'
        trace.mode = 'lines+markers'
      })
      let layout = {
        legend: {
          orientation: 'h',
          y: 1.2
        },
        hovermode: 'x unified'
      }
      let config = {
        responsive: true,
        scrollZoom: true,
        displaylogo: false,
        displayModeBar: true
      }
      BriqueChart.newPlot('virtualParameterChart', traces, layout, config)
    },
    /**
     * Virtual Parameter data reset (신규 Virtual Parameter 입력 시)
     */
    newBtnProcess () {
      this.paramName = null
      this.code = this.codeGuide
      this.parameterData = null
      this.isNew = true
      this.validationOption = null
      this.selectedLots = []
      // this.chartData = []
      // this.yMax = null
      // this.yMin = null
    },
    /**
     * Virtual Parameter 저장
     */
    async saveData () {
      // virtual data 생성
      // [new 일 경우]
      //   vid            : virtualYn이 Y인 데이터의 vid max 값을 조회하여
      //                    값이 있을 경우에는 +1
      //                    값이 없을 경우에는 90,000,001
      //   vid_type       : VP(Virtual Parameter)
      //   param_name     : 입력 받기
      //   param_desc     : null
      //   alias_name     : param_name 과 동일
      //   use_yn         : Y
      //   virtual_yn     : Y
      //   virtual_data   : editor 입력값
      //   number_yn      : Y
      //   list_yn        : N
      //   list_position  : 1
      //   list_delimiter : null
      //   value_unit     : null
      //   offset_type    : null
      //   offset_value   : 0
      // [edit 일 경우]
      //   param_name & virtual_data 만 update
      let self = this
      let selectEqpVo = this.searchTreeNode.detail
      let data
      if (this.isNew) {
        data = {
          fab: selectEqpVo.fab,
          eqpId: selectEqpVo.eqpId,
          moduleId: selectEqpVo.moduleId,
          paramName: this.paramName,
          virtualData: this.code,
          vidType: 'VPID'
        }
      } else {
        data = this.parameterData
        data.virtualData = this.code
      }

      if (!this.saveValidation(data)) {
        return
      }

      let message = this.$t('fdc.COMMON.MESSAGE.CONFIRM_SAVE')

      this.$dialog.confirm({
        message: message,
        cancelText: this.$t('fdc.COMMON.BUTTON.CANCEL'),
        confirmText: this.$t('fdc.COMMON.BUTTON.CONFIRM'),
        onConfirm: function () {
          function saveLastProcess (response) {
            if (response != null && response.status === 200) {
              self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.SUCCEED_SAVE'))
              if (Object.keys(self.$route.query).length === 0 && JSON.stringify(self.$route.query) === JSON.stringify({})) {
                let node = self.searchTreeNode
                self.listFn(node.detail.fab, node.detail.eqpId, node.detail.moduleId)
                self.paramName = null
                self.code = self.codeGuide
                self.parameterData = null
                self.isNew = true
                // self.chartData = []
                // self.yMax = null
                // self.yMin = null
              } else {
                location.reload()
              }
            } else {
              self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.FAILED_SAVE'))
            }
          }

          let isNew = self.isNew
          if (isNew) {
            // insert
            API.FdcEqpInfo.createVirtualParam(data).then(result => {
              saveLastProcess(result)
            })
          } else {
            // update
            delete data['_status']
            API.FdcEqpInfo.updateVirtualParam(data).then(result => {
              saveLastProcess(result)
            })
          }
        },
        onCancel: function () {}
      })
    },
    /**
     * Virtual Parameter Save Validation
     * @param {Object} data save data
     * @returns {Boolean} validation 성공 여부
     */
    saveValidation (data) {
      if (!data.paramName || data.paramName.trim() === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Parameter Name']))
        return false
      } else if (!data.virtualData || data.virtualData.trim() === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Virtual Data']))
        return false
      }
      return true
    },
    /**
     * Virtual Parameter 삭제
     * 실제 삭제가 아니라 Use YN만 'N'으로 변경합니다.
     */
    async deleteData () {
      let self = this
      let data
      if (!this.isNew) {
        data = this.parameterData
        data.useYn = 'N'
      }

      let message = this.$t('fdc.COMMON.MESSAGE.CONFIRM_DELETE')

      this.$dialog.confirm({
        message: message,
        cancelText: this.$t('fdc.COMMON.BUTTON.CANCEL'),
        confirmText: this.$t('fdc.COMMON.BUTTON.CONFIRM'),
        onConfirm: function () {
          function deleteLastProcess (response) {
            if (response != null && response.status === 200) {
              self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.SUCCEED_DELETE'))
              let node = self.searchTreeNode
              self.listFn(node.detail.fab, node.detail.eqpId, node.detail.moduleId)
              self.paramName = null
              self.code = self.codeGuide
              self.parameterData = null
              self.isNew = true
              // self.chartData = []
              // self.yMax = null
              // self.yMin = null
            } else {
              self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.FAILED_DELETE'))
            }
          }

          delete data['_status']
          API.FdcEqpInfo.updateVirtualParam(data).then(result => {
            deleteLastProcess(result)
          })
        },
        onCancel: function () {}
      })
    },
    /**
     * Delete 가능 여부 체크
     * @returns {Boolean} Delete 가능 여부
     * Virtual Parameter data 존재 여부로 Delete Button 활성화를 조절합니다.
     */
    deleteEnable () {
      if (!this.parameterData) {
        return false
      } else {
        return true
      }
    },
    /**
     * Save 가능 여부 체크
     * @returns {Boolean} Save 가능 여부
     * 검색된 EQP Tree node가 있는지 여부를 가지고 Save Button 활성화를 조절합니다.
     */
    saveEnable () {
      if (!this.searchTreeNode.detail) {
        return false
      } else {
        let selectEqpVo = this.searchTreeNode.detail
        if (selectEqpVo.fab !== null &&
          selectEqpVo.eqpId !== null &&
          selectEqpVo.moduleId !== null) {
          return true
        }
        return false
      }
    },
    /**
     * Monaco Editor의 code value 동기화 (화면에 code data와 동기화)
     * @param {*} value Javascript Code
     */
    setCodeValue (value) {
      this.code = value
    },
    /**
     * Monaco Editor의 cursor position 동기화 (화면에 cursorPosition data와 동기화)
     * @param {*} value Cursor Position
     */
    getCursorPosition (value) {
      this.cursorPosition = value
    },
    /**
     * Validation Option check
     * @returns {Boolean} option check 결과
     * Option 선택 시 기간 또는 Select Lot button의 활성화를 조절합니다.
     */
    checkValidationOption () {
      if (this.validationOption === 'period') {
        return true
      } else if (this.validationOption === 'selectLot') {
        return false
      }
    },
    /**
     * Select Lot Modal 열기
     */
    showLotsModal () {
      if (!this.searchTreeNode.detail) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['EQP']))
      } else {
        let modelData = {
          fab: this.searchTreeNode.detail.fab,
          eqpId: this.searchTreeNode.detail.eqpId,
          moduleId: this.searchTreeNode.detail.moduleId
        }
        this.selectedModelData = modelData
        this.selectLotsModal.visible = true
      }
    },
    /**
     * Select Lot Modal 닫기
     * @param {Boolean} value Modal 표시 여부
     */
    resetModalData (value) {
      this.selectLotsModal.visible = value
    },
    /**
     * Lots Apply
     * @param {Array} list 선택된 lot 목록 배열
     * Validation 조건으로 설정
     */
    applyLots (list) {
      this.selectedLots = list
    },
    /**
     * Code 목록 조회
     * @param {String} type code type
     * Free Define Function Name 목록을 조회합니다.
     */
    async getCodeList (type) {
      var payload = {
        codeType: type
      }
      var data = await API.Common.getCodesString(payload)
      if (type === 'freeDefineFunctionName') {
        this.functionList = data
      }
    },
    /**
     * BRIQUE Grid cell double click event
     * @param {*} event event
     */
    onCellDoubleClick (event) {
      const data = event.data
      this.parameterData = null
      this.paramName = null
      this.code = this.codeGuide
      if (data !== undefined && data !== null) {
        if (data.virtualYn !== 'Y') {
          this.$dialog.alert(this.$t('fdc.EQP_INFO.MESSAGE.INFORM_NOT_VIRTUAL'))
          // this.parameterListGrid.select(-1, -1)
        } else {
          this.parameterData = data
          this.paramName = data.paramName
          this.code = data.virtualData ? data.virtualData : this.codeGuide
          this.isNew = false
          this.validationOption = 'period'
          this.selectedLots = []
          // this.chartData = []
          // this.yMax = null
          // this.yMin = null
        }
      }
    }
  },
  data () {
    const today = new Date()
    return {
      // treeNodes: [],
      // nodeIds: [],
      // columns: [
      //   { label: this.$t('fdc.COMMON.COLUMN.PARAM_NAME'), binding: 'paramName', width: '2*', modifiable: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.ALIAS_NAME'), binding: 'aliasName', width: '2*', modifiable: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.VIRTUAL'), binding: 'virtualYn', width: '1*', readOnly: true }
      // ], // grid column 배열
      columns: [], // grid column 배열
      defaultColDef: {
        // minWidth: 100,
        filter: true,
        sortable: true,
        resizable: true
      }, // BRIQUE Grid column default setting
      rowData: [], // grid row data
      selectedTreeNode: [], // 선택된 EQP Tree node
      searchTreeNode: [], // 검색한 EQP Tree node
      parameterData: null, // 선택/조회한 Parameter Data
      fromDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1), // Validation Option > Period > From Date
      fromMinDate: null, // Validation Option > Period > From Date Min data
      fromMaxDate: new Date(today.getFullYear(), today.getMonth(), today.getDate()), // Validation Option > Period > From Date Max data
      fromTime: today, // Validation Option > Period > From Time
      fromMinTime: null, // Validation Option > Period > From Time Min data
      fromMaxTime: today, // Validation Option > Period > From Time Max data
      toDate: new Date(today.getFullYear(), today.getMonth(), today.getDate()), // Validation Option > Period > To Date
      toMinDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1), // Validation Option > Period > To Date Min data
      toMaxDate: new Date(today.getFullYear(), today.getMonth(), today.getDate()), // Validation Option > Period > To Date Max data
      toTime: today, // Validation Option > Period > To Time
      toMinTime: today, // Validation Option > Period > To Time Min data
      toMaxTime: null, // Validation Option > Period > To Time Max data
      // chartData: [], // Chart data
      // yMax: null, // Chart y축 Max data
      // yMin: null, // Chart y축 Min data
      paramName: '', // Virtual Parameter Name
      code: [
        '/*',
        ' * @desc',
        ' * (' + this.$t('fdc.EQP_INFO.MESSAGE.CODE_DESC_001') + ')',
        ' *  - ' + this.$t('fdc.EQP_INFO.MESSAGE.CODE_DESC_002'),
        ' *  - ' + this.$t('fdc.EQP_INFO.MESSAGE.CODE_DESC_003'),
        ' *  - ' + this.$t('fdc.EQP_INFO.MESSAGE.CODE_DESC_004'),
        ' *     ' + this.$t('fdc.EQP_INFO.MESSAGE.CODE_DESC_005'),
        ' *     ' + this.$t('fdc.EQP_INFO.MESSAGE.CODE_DESC_006'),
        ' *     ' + this.$t('fdc.EQP_INFO.MESSAGE.CODE_DESC_007'),
        // ' * (중요) function의 이름을 변경하지 마십시오.',
        // ' *       Parameter List에서 Drag & Drop 시 getParameterValue("Parameter Name", time)를 추가할 수 있습니다.',
        ' */',
        'function virtual() {',
        '\t',
        '}',
        ''
      ].join('\n'), // Javascript code 기본값
      codeGuide: [
        '/*',
        ' * @desc',
        ' * (' + this.$t('fdc.EQP_INFO.MESSAGE.CODE_DESC_001') + ')',
        ' *  - ' + this.$t('fdc.EQP_INFO.MESSAGE.CODE_DESC_002'),
        ' *  - ' + this.$t('fdc.EQP_INFO.MESSAGE.CODE_DESC_003'),
        ' *  - ' + this.$t('fdc.EQP_INFO.MESSAGE.CODE_DESC_004'),
        ' *     ' + this.$t('fdc.EQP_INFO.MESSAGE.CODE_DESC_005'),
        ' *     ' + this.$t('fdc.EQP_INFO.MESSAGE.CODE_DESC_006'),
        ' *     ' + this.$t('fdc.EQP_INFO.MESSAGE.CODE_DESC_007'),
        ' */',
        'function virtual() {',
        '\t',
        '}',
        ''
      ].join('\n'), // Javascript code 기본값 백업
      isNew: true, // 신규 Virtual Parameter인지 여부
      nodeObj: null, // Parameter Manager에서 연동할 경우 이전 화면에서 선택된 EQP Tree node data
      cursorPosition: null, // Editor Cursor Position
      validationOption: 'period', // Validation Option data
      selectLotsModal: {
        visible: false
      }, // Select Lot Modal 표시 여부
      selectedLots: [], // 선택된 Lot 목록 배열
      selectedModelData: null, // Select Lot Modal 표시할 때 기초 data (lot 목록 검색 조건)
      functionName: 'getParameterValue', // Javascript Free Define Function Name - Editor에서 intellisense로 사용함.
      functionList: null, // Javascript Free Define Function 목록
      editorParamList: [], // Monaco Editor에 전달되는 Parameter 목록 배열
      editorContextNameList: [], // Monaco Editor에 전달되는 Context Name 목록 배열
      editorStepList: [] // Monaco Editor에 전달되는 Step 목록 배열
      // editorKey: 0
    }
  }
}
